// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Custom turbo-stream action: full-page visit to the URL carried in the
// stream's target attribute. Lets a form inside a turbo-frame (the weighing
// shell's New aircraft modal) escape its frame after a successful create.
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target)
}

// Required fields the server rendered red for being blank (Bootstrap's
// is-invalid) turn back to normal the moment they hold a value — typed,
// selected, or set by a picker (the airport picker dispatches a bubbling
// change event) — and go red again only if emptied before saving. A save
// re-renders the state from the server, so this is purely the pre-save cue.
const syncRequiredCue = ({ target }) => {
  if (!(target instanceof HTMLElement) || typeof target.value !== "string") return
  const blank = target.value.trim() === ""
  if (!blank && target.classList.contains("is-invalid")) {
    target.classList.remove("is-invalid")
    target.dataset.blankCue = ""
  } else if (blank && "blankCue" in target.dataset) {
    target.classList.add("is-invalid")
  }
}
document.addEventListener("input", syncRequiredCue)
document.addEventListener("change", syncRequiredCue)
